import { Page } from '@app/components/page/Page';
import { UserIcon } from '@app/components/users/UserIcon';
import { fetchUsers } from '@app/modules/admin/api';
import { AddButton } from '@app/modules/admin/components/AddButton';
import { AdminModule } from '@app/modules/admin/index';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { UsersList } from './UsersList';

export const ListUsersPage = () => {
  const { $t } = useIntl();
  const title = $t({
    id: 'admin.users.listScreen.title',
    defaultMessage: 'Administrar usuarios',
  });

  const query = useQuery({
    queryKey: ['users'],
    queryFn: () =>
      fetchUsers({
        page: 0,
        pageSize: 9999,
      }),
  });

  return (
    <Page data-cy="users-list-screen" htmlTitle={title}>
      <Page.Header
        icon={<UserIcon />}
        title={title}
        actions={
          <AddButton
            to="/admin/users/add"
            label={$t({
              id: 'admin.users.listScreen.links.createUser',
              defaultMessage: 'Crear usuario',
            })}
          />
        }
        breadcrumbs={<Page.ModuleBreadcrumbs module={AdminModule} />}
      />
      <Page.Content>
        <UsersList query={query} />
      </Page.Content>
    </Page>
  );
};
